/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ClientError } from '../model/clientError.model';
// @ts-ignore
import { ContractType } from '../model/contractType.model';
// @ts-ignore
import { SubstateFlagType } from '../model/substateFlagType.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ContractExportControllerService {

    protected basePath = 'http://localhost/assets-backend/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(@Inject(HttpClient) protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Inject(Configuration) @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param projectKey 
     * @param exportName 
     * @param departmentId 
     * @param sortDir 
     * @param sortedBy 
     * @param state 
     * @param sentForSignatureFlag 
     * @param substateFlag 
     * @param revisionId 
     * @param validityState 
     * @param contractNumberOfficial 
     * @param existencyDate 
     * @param existencyIntervalFrom 
     * @param existencyIntervalTo 
     * @param endWithinYear 
     * @param subjectSearchText 
     * @param subjectId 
     * @param subcontract 
     * @param area 
     * @param contractGroupId 
     * @param contractType 
     * @param _export 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContractExport(projectKey: string, exportName: string, departmentId?: number, sortDir?: string, sortedBy?: string, state?: Array<string>, sentForSignatureFlag?: Array<boolean>, substateFlag?: Array<SubstateFlagType>, revisionId?: Array<number>, validityState?: Array<string>, contractNumberOfficial?: string, existencyDate?: string, existencyIntervalFrom?: string, existencyIntervalTo?: string, endWithinYear?: boolean, subjectSearchText?: string, subjectId?: number, subcontract?: boolean, area?: Array<number>, contractGroupId?: number, contractType?: Array<ContractType>, _export?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getContractExport(projectKey: string, exportName: string, departmentId?: number, sortDir?: string, sortedBy?: string, state?: Array<string>, sentForSignatureFlag?: Array<boolean>, substateFlag?: Array<SubstateFlagType>, revisionId?: Array<number>, validityState?: Array<string>, contractNumberOfficial?: string, existencyDate?: string, existencyIntervalFrom?: string, existencyIntervalTo?: string, endWithinYear?: boolean, subjectSearchText?: string, subjectId?: number, subcontract?: boolean, area?: Array<number>, contractGroupId?: number, contractType?: Array<ContractType>, _export?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getContractExport(projectKey: string, exportName: string, departmentId?: number, sortDir?: string, sortedBy?: string, state?: Array<string>, sentForSignatureFlag?: Array<boolean>, substateFlag?: Array<SubstateFlagType>, revisionId?: Array<number>, validityState?: Array<string>, contractNumberOfficial?: string, existencyDate?: string, existencyIntervalFrom?: string, existencyIntervalTo?: string, endWithinYear?: boolean, subjectSearchText?: string, subjectId?: number, subcontract?: boolean, area?: Array<number>, contractGroupId?: number, contractType?: Array<ContractType>, _export?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getContractExport(projectKey: string, exportName: string, departmentId?: number, sortDir?: string, sortedBy?: string, state?: Array<string>, sentForSignatureFlag?: Array<boolean>, substateFlag?: Array<SubstateFlagType>, revisionId?: Array<number>, validityState?: Array<string>, contractNumberOfficial?: string, existencyDate?: string, existencyIntervalFrom?: string, existencyIntervalTo?: string, endWithinYear?: boolean, subjectSearchText?: string, subjectId?: number, subcontract?: boolean, area?: Array<number>, contractGroupId?: number, contractType?: Array<ContractType>, _export?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (projectKey === null || projectKey === undefined) {
            throw new Error('Required parameter projectKey was null or undefined when calling getContractExport.');
        }
        if (exportName === null || exportName === undefined) {
            throw new Error('Required parameter exportName was null or undefined when calling getContractExport.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (departmentId !== undefined && departmentId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>departmentId, 'departmentId');
        }
        if (sortDir !== undefined && sortDir !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDir, 'sortDir');
        }
        if (sortedBy !== undefined && sortedBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortedBy, 'sortedBy');
        }
        if (state) {
            state.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'state');
            })
        }
        if (sentForSignatureFlag) {
            sentForSignatureFlag.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sentForSignatureFlag');
            })
        }
        if (substateFlag) {
            substateFlag.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'substateFlag');
            })
        }
        if (revisionId) {
            revisionId.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'revisionId');
            })
        }
        if (validityState) {
            validityState.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'validityState');
            })
        }
        if (contractNumberOfficial !== undefined && contractNumberOfficial !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractNumberOfficial, 'contractNumberOfficial');
        }
        if (existencyDate !== undefined && existencyDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>existencyDate, 'existencyDate');
        }
        if (existencyIntervalFrom !== undefined && existencyIntervalFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>existencyIntervalFrom, 'existencyIntervalFrom');
        }
        if (existencyIntervalTo !== undefined && existencyIntervalTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>existencyIntervalTo, 'existencyIntervalTo');
        }
        if (endWithinYear !== undefined && endWithinYear !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endWithinYear, 'endWithinYear');
        }
        if (subjectSearchText !== undefined && subjectSearchText !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>subjectSearchText, 'subjectSearchText');
        }
        if (subjectId !== undefined && subjectId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>subjectId, 'subjectId');
        }
        if (subcontract !== undefined && subcontract !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>subcontract, 'subcontract');
        }
        if (area) {
            area.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'area');
            })
        }
        if (contractGroupId !== undefined && contractGroupId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractGroupId, 'contractGroupId');
        }
        if (contractType) {
            contractType.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractType');
            })
        }
        if (_export !== undefined && _export !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>_export, 'export');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/${this.configuration.encodeParam({name: "projectKey", value: projectKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/contracts/export/${this.configuration.encodeParam({name: "exportName", value: exportName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
